// extracted by mini-css-extract-plugin
export var borderRadius = "_a7-4";
export var large = "_a7-3";
export var logoContainer = "_a7-0";
export var nameLogo = "_a7-2";
export var small = "_a7-1";